export const SkinColors = {
  Basic: "Basic Skin",
  DefaultBlueBg: "Default skin - Blue background",
  DefaultBlueFg: "Default black skin - Blue foreground",
  DefaultYellowBg: "Default skin - Yellow background",
  DefaultYellowFg: "Default black skin - Yellow foreground"
};
